import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import React from "react";

class UploadImage extends React.Component {
  render() {
    return (
      <div>
        <label className="upload-photo" htmlFor="file">
          <img
            style={{
              display: "inline-block",
              width: "130px",
              height: "130px",
              borderRadius: "50%",
              objectFit: "cover",
              cursor: "pointer",
            }}
            src={this.props.profilePic || UploadPhoto}
            alt="profile"
          />
          <div
            style={{ textAlign: "center", width: "130px", color: "#ff431b" }}
          >
            <div
              title="Upload Photo"
              style={{
                cursor: "pointer",
                fontSize: "18px",
                marginTop: "5px",
              }}
              className="background_white"
            >
              Upload photo
            </div>
          </div>
        </label>
        <input
          id="file"
          style={{ display: "none" }}
          type="file"
          name="profilePic"
          accept=".png, .jpeg, .jpg"
          onChange={this.props.onImageChange.bind(this)}
        />
      </div>
    );
  }
}

export default UploadImage;
